import { View } from "binder"
import { ProductionRestart, ProductionRestartManipulationViewModel } from "./productionRestartManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ProductionRestartManipulationView extends View<ProductionRestartManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-E459F6D4-CB3D-4CAD-8C21-B8A4B157FA5E"
    }
    loadHtml(): string {
        let element = require('./productionRestartManipulation.html').default;
        let style = require('./productionRestartManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionRestarts(v: ProductionRestart) { this._productionRestarts = v; } public get productionRestarts(): ProductionRestart { return this._productionRestarts; } private _productionRestarts: ProductionRestart;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;
}
